import { makeStyles } from '@material-ui/core';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React from 'react';
import { Translate } from 'react-localize-redux';

import { HORIZONTAL_SPACE_CLASSNAME } from '../../../ui/Layout';
import GridDivider from './GridDivider';
import VoucherIncludeDeliveryFeeFormField from './VoucherIncludeDeliveryFeeFormField';
import VoucherTakesPriorityFormField from './VoucherTakesPriorityFormField';
import VoucherValidForFormField from './VoucherValidForFormField';
import VoucherValidOnOrdersOverFormField from './VoucherValidOnOrdersOverFormField';

const useStyles = makeStyles({
  summary: {
    paddingLeft: 0,
    paddingRight: 0,
  },
});

type Props = { automaticallyApply: boolean };

// fix Mui forgotten muiName prop
// @ts-ignore
ExpansionPanelDetails.muiName = 'ExpansionPanelDetails';

const AdvancedOptionsFormItems = (props: Props) => {
  const classes = useStyles();

  return (
    <ExpansionPanel elevation={0} className={HORIZONTAL_SPACE_CLASSNAME}>
      <ExpansionPanelSummary
        expandIcon={<ExpandMoreIcon />}
        style={{ paddingLeft: 0 }}
        data-fd="show-advanced-options"
        className={classes.summary}
      >
        <Typography>
          <Translate id="Show_advanced_options" />
        </Typography>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails>
        <Grid container>
          <Grid item xs={12}>
            <VoucherTakesPriorityFormField disabled={!props.automaticallyApply} />
          </Grid>

          <GridDivider />

          <Grid item xs={12}>
            <VoucherValidOnOrdersOverFormField />
          </Grid>

          <GridDivider />

          <Grid item xs={12}>
            <VoucherIncludeDeliveryFeeFormField />
          </Grid>

          <GridDivider />

          <Grid item xs={12}>
            <VoucherValidForFormField />
          </Grid>
        </Grid>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  );
};

export default AdvancedOptionsFormItems;
